import React from "react";
import { Table  } from 'antd';
import Card from "components/card";
import { connect } from "react-redux";
import { NumberFormatter } from "../../../../utils/index";

const PayrunSalaryAdjustmentTable = ({recordData, ...props}) => {  	
  	const columns = [		
	    {
	        title: `Payroll Date`,
	        dataIndex: 'payroll_cutoff',
	        key: 'payroll_cutoff',
	        width: '80%',  
	    },
	    {
	        title: <div className="text-right">Amount</div>,
	        dataIndex: 'ppa_amount',
	        key: 'ppa_amount',
	        width: '20%',	
	        render: (ppa_amount) => <div className="text-right">{NumberFormatter(ppa_amount)}</div>       
	    },	    
    ];

  	return (
	    <Card extra={"w-full h-full p-4 mt-5"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordData?.sdj_payroll_payrun_adjustments} 
		        	columns={columns}
		            rowKey={(record) => record.ppa_id}		            
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.salaryAdjustment.salaryAdjustmentDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrunSalaryAdjustmentTable);